<template>
  <div class="ai-visibility-step-nav">
    <div class="ai-visibility-step-nav__line"></div>
    <div
      v-for="(step, index) in steps"
      :key="step.key"
      class="ai-visibility-step-nav__item"
    >
      <span
        class="ai-visibility-step-nav__dot"
        :class="{
          'ai-visibility-step-nav__dot--current': index === currentStep,
          'ai-visibility-step-nav__dot--complete': index < currentStep,
        }"
      >
        <i v-if="index < currentStep" class="material-icons">check</i>
        <span v-else>{{ index + 1 }}</span>
      </span>
      <span class="ai-visibility-step-nav__label">{{ step.label }}</span>
    </div>
  </div>
</template>

<script>
import { AI_VISIBILITY_STEPS } from '../constants'

export default {
  name: 'SetupStepNav',
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      steps: AI_VISIBILITY_STEPS,
    }
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-step-nav {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 22px;
}

.ai-visibility-step-nav__line {
  position: absolute;
  top: 1px;
  bottom: 1px;
  left: 20px;
  width: 1px;
  background: var(--v-gray12Color-base);
}

.ai-visibility-step-nav__item {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-visibility-step-nav__dot {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--v-gray12Color-base);
  border-radius: 50%;
  background: var(--v-cardBg-base);
  color: var(--v-mainColor3-base);
  font-size: 14px;
  font-weight: 400;
}

.ai-visibility-step-nav__dot--current {
  border-color: var(--v-profileAnchorColor-base);
  font-weight: 700;
}

.ai-visibility-step-nav__dot--complete {
  border-color: var(--v-green7Color-base);
  color: var(--v-green7Color-base);

  i {
    font-size: 22px;
  }
}

.ai-visibility-step-nav__label {
  color: var(--v-mainColor3-base);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
}
</style>
